import { Result } from '../../assets/src/utils/Result';
import { Deferred, deferred } from '../../assets/src/utils/deferred';
import { IPlatformPreloader, loadScriptWithRetries, stringifyValue } from './IPlatformPreloader';

export class FbPlatformPreloader implements IPlatformPreloader {
	private _initialized = false;
	private _initCompleted: Deferred<Result>;

	public get initialized(): boolean {
		return this._initialized;
	}

	public set initialized(value: boolean) {
		this._initialized = value;
	}

	public async loadAndInit(): Promise<Result> {
		if (this._initCompleted) {
			return this._initCompleted.promise;
		}

		// для personal env (localhost) скрипт с fb sdk подгружаем динамически
		if (typeof FBInstant === 'undefined') {
			const fbInstantLoaded = await loadScriptWithRetries('//connect.facebook.net/en_US/fbinstant.7.1.js');
			if (fbInstantLoaded.success === false) {
				return Result.Error(fbInstantLoaded.error);
			}
		}

		// для остальных окружение sdk уже доступно к этому моменту так как оно подключается через <script> в index.html
		// наличие <script> в index.html - это требование FB
		if (!FBInstant) {
			return Result.Error('script was loaded but FBInstant is not available');
		}

		// TODO add retries
		this._initCompleted = deferred<Result>();
		FBInstant.initializeAsync()
			.then(() => {
				this._initialized = true;
				this._initCompleted.resolve(Result.Ok());
			})
			.catch((error) => this._initCompleted.resolve(Result.Error(stringifyValue(error))));

		return this._initCompleted.promise;
	}

	public setLoadingProgress(progress: number): void {
		// для использование прелоадера необязательно ждать инициализации
		if (typeof FBInstant !== 'undefined') {
			FBInstant.setLoadingProgress(progress);
		}
	}
}
